import { Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  value: ReactNode;
  valueClassName?: string;
}

export const DetailRow = ({ label, value, valueClassName }: DetailRowProps) => {
  return (
    <Stack direction="row" justify="between" align="center">
      <Typography size="sm" className="al-text-muted-foreground">
        {label}
      </Typography>
      <Typography size="sm" weight="medium" className={valueClassName}>
        {value}
      </Typography>
    </Stack>
  );
};
